import React, { useEffect } from "react";
import Layout from "../../container/Layout";
import './style.css'

const GoldLoan = () => {

    useEffect(() =>{
        window.scrollTo(0, 0)
    },[])
    

    return (
        <Layout>
            <img src="images/gold-loan.jpg" class="banner-img" />

            <div className="container">
                <div className="container-box row">

                    <div className="col-md-7 mt-2">
                       <h1 className="featured-heading"> Features & Benefits- </h1>

                       <ul className="featured-list mt-5">
                           <li> Avail loan upto 80 Per Cent of Value. </li>
                           <li> Loan available at attractive ROI of 0.98 % pm. </li>
                           <li> Hassle-free quick processing of loans. </li>
                           <li> Minimum documentation and quick disbursal. </li>
                           <li>  Easy Payment options. ATL - Anytime Liquidity </li>
                           <li> No EMI, Service only Interest and enjoy the Loan facility </li>
                       </ul>
                    </div>

                    <div className="col-md-5">
                        <div className="loan-box">
                            <h3> Loan Product  </h3>
                            <p className="gold-loan-desc">  Demand Loan</p>

                            <div className="interest">
                                <h4 className="interest-heading"> RATE OF INTEREST </h4>
                            </div>

                            <div className="percentage">
                                0.98% P.M.
                            </div>
                            <div>


                                <div className="text-center">
                                    <button className="load-btn"> Apply Online</button>

                                </div>

                            </div>

                        </div>


                    </div>

                </div>
            </div>
        </Layout>
    )
}


export default GoldLoan;